
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { Calendar } from 'lucide-react';

interface CalendlyLinkFieldProps {
  calendlyLink: string;
  onCalendlyLinkChange?: (value: string) => void;
}

export function CalendlyLinkField({
  calendlyLink,
  onCalendlyLinkChange
}: CalendlyLinkFieldProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="calendly-link" className="flex items-center gap-2">
        <Calendar className="h-4 w-4" />
        <span>Calendly Link</span>
      </Label>
      <Input
        id="calendly-link"
        placeholder="https://calendly.com/your-link"
        value={calendlyLink}
        onChange={(e) => {
          if (onCalendlyLinkChange) {
            onCalendlyLinkChange(e.target.value);
          }
        }}
      />
      <p className="text-sm text-muted-foreground">
        Enter your Calendly link to allow users to schedule calls after completing the assessment.
      </p>
    </div>
  );
}
